import {Nullish} from 'shared/web';

import {filterByMinMax} from './filterByMinMax';

const POWER_VALUES = [0, 20, 40, 60, 80, 100];

export const getFeatureScoreOptions = (min?: number | Nullish, max?: number | Nullish) =>
  filterByMinMax(min, max)(POWER_VALUES);
